import { IConfirmEmailParameters } from 'services/auth/auth.slice'
import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new CachedRequest(1000 * 5)

export async function apiValidateEmailConfirmation(args: IConfirmEmailParameters) {
  return instance.post(endpoint.validateEmailConfirmation, args)
}